<template>
  <div class="landing-page">
    <LandingHome />
    <LazyVisibleLandingOffer hydrate-on-visible />
    <LazyVisibleLandingHowItWorks hydrate-on-visible />
    <LazyVisibleLandingSafety hydrate-on-visible />
    <LazyVisibleLandingPageTestimonials
      v-if="testimonials?.length"
      :testimonials-data="testimonials"
      hydrate-on-visible
    />
    <LazyVisibleLandingPageBoostCredit hydrate-on-visible />
  </div>
</template>

<script setup lang="ts">
import LandingHome from "~/features/landing-page/components/LandingHome.vue";
import { useLandingTestimonials } from "~/features/landing-page/composables/useLandingTestimonials";

export type { TestimonialItem } from "~/features/landing-page/composables/useLandingTestimonials";

const { testimonials, suspense } = useLandingTestimonials();

onServerPrefetch(async () => {
  await suspense();
});
</script>

